export const ADD_BY_CSV = "add-by-csv";
export const ADD_CREDIT_CARD = "add-credit-card";
export const ADD_RECIPIENTS_CONFIRMATION = "add-recipients-confirmation";
export const BRAND_MARKETPLACE = "brand-marketplace";
export const BONUS_POINTS_CONFIRMATION = "bonus-points-confirmation";
export const EDIT_CATALOG_CANCEL_SAVED_CHANGES = "edit-catalog-cancel-saved-chages";
export const EDIT_SHOP_CATEGORY = "edit-shop-category";
export const EXPIRE_ORGANIZATION_ORDER = "expire-organisation-order";
export const FALLBACK_SHOP_LOADER = "fallback-shop-loader";
export const ORDER_CONFIRMATION = "order-confirmation";
export const ORDER_DETAILS_ACTIONS = "order-details-action";
export const REMOVE_RECIPIENT = "remove-recipient";
export const SHARE_SHOP = "share-shop";
export const THANK_YOU_MESSAGE = "thank-you-message";
export const CATALOG_HOW_IT_WORKS = "catalog-how-it-works";
export const RESTORE_DEFAULT_CATALOG = "restore-default-catalog";
export const RULES = "rules";
export const SEARCH_TEMPLATES = "search-templates";
export const TEMPLATE_CATEGORIES = "template-categories";
export const SHOP_GIFT_BALANCES = "shop-gift-balances";
export const SEND_THANKYOU = "send-thankyou";
export const CATALOG_PRODUCT_DETAIL_MODAL = "catalog-product-detail";
export const REMOVE_FROM_CATALOG_CONFIRMATION_MODAL = "remove-from-catalog-confirmation";
export const MANAGE_CATALOG_PRODUCTS = "manage-catalog-products";
export const UNIVERSAL_POINTS_CONFIRMATION = "universal-points-confirmation";
export const CREATE_SHARED_WALLET_CONFIRMATION_MODAL = "create-shared-wallet-confirmation-modal";
export const TEMPLATE_INFO = "template-info";
export const ADD_LOGO_MODAL = "add-logo-modal";
export const CREATE_SHOP_CONFIRMATION = "create-shop-confirmation";
export const OPEN_ORDER_HOW_IT_WORKS = "open-order-how-it-works";
export const APPROVE_RECIPIENTS_TOOLTIP_MODAL = "see-all-recipient-tooltip-modal";
export const APPROVE_RECIPIENTS_CONFIRMATION = "approve-recipients-confirmation";
export const REJECT_RECIPIENT = "reject-recipient";
export const DELETE_INCOMPLETE_ORGANISER_ORDER = "delete-incomplete-organiser-order";
export const ONDEMAND_KIT_ITEMS = "ondemand-kit-items";
export const WAREHOUSE_KIT_ITEMS = "warehouse-kit-items";
export const KIT_ORDER_CONFIRMTAION = "kit-order-confirmation";
export const DELETE_KIT = "delete-kit";
export const DELETE_CAMPAIGN = "delete-campaign";
export const DEACTIVATE_CAMPAIGN = "deactivate-campaign";
export const ACTIVATE_CAMPAIGN = "activate-campaign";
export const ACTIVATE_CAMPAIGN_ERROR = "activate-campaign-error";
export const FAILED_CAMPAIGN_ORDERS = "failed-campaign-orders";
export const FAILED_CAMPAIGN_ORDERS_NEW = "failed-campaign-orders-new";
export const MULTIPLE_FAILED_CAMPAIGNS = "multiple-failed-campaigns";
export const CAMPAIGN_ORDER_CONFIRMTAION = "campaign-order-confirmation";
export const CAMPAIGN_CUSTOM_DATE_MODAL = "campaign-custom-date";
export const CHECKOUT_OPTIONS_INFO = "checkout-options-info";
export const MY_ORDER_PENDING_POINTS_MODAL = "my-order-pending-points";
export const PENDING_POINTS_MODAL = "pending-points-modal";
export const OUT_OF_STOCK_MODAL = "out-of-stock-modal";
export const PRODUCT_FILTER_MODAL = "product-filter-modal";
export const SEND_POINTS_PREVIEW_MESSAGE = "send-points-preview-message";
export const WHITE_LABEL_INFO_MODAL = "white-lable-info";
export const ADD_CUSTOM_CURRENCY_MODAL = "add-custom-currency-modal";
export const EDIT_ORDER_NAME_MODAL = "edit-order-name";
export const EDIT_RECIPIENT_MESSAGE_MODAL = "edit-recipient-message-modal";
export const TOOLTIP_MOBILE_MODAL = "tooltip-mobile-modal";
export const EDIT_KIT_NAME_MODAL = "edit-kit-name";
export const ADD_SHOP_LOGO = "add-shop-logo";
export const TRANSFER_POINTS_MODAL = "transfer-points";
export const UNABLE_TO_ARCHIVE_SHOP_MODAL = "unable-to-archive-shop";
export const ARCHIVE_SHOP_MODAL = "archive-shop";
export const DELETE_SHOP_USER_MODAL = "delete-shop-user";
export const DOWNLOAD_REPORT = "download-report";
export const REMOVE_CAMPAIGN_ORDER = "remove-campaign-order";
export const REPROCESS_CAMPAIGN_ORDER = "reprocess-campaign-order";
export const REPROCESS_ALL = "reprocess-all";
export const CREATE_KITTED_SWAG = "create-kitted-swag";
export const CREATE_ONDEMAND_SWAG = "create-ondemand-swag";
export const RECOGNITION_PROGRAM_ORDER_CONFIRMATION = "recognition-program-order-confirmation";
export const RECOGNITION_PROGRAM_USERS_CONFIRMATION = "recognition-program-users-confirmation";
export const SHOP_USER_INFO_MODAL = "shop-user-info-modal";
export const DOWNLOAD_INVOICE_MODAL = "download-invoice";
export const BRANDED_BOX_STICKER_MODAL = "branded-box-sticker";
export const PREMIUM_BOX_STICKER_MODAL = "premium-box-sticker";
export const WORKSPACE_SUCCESS_MODAL = "workspace-success";
export const WORKSPACE_DISMISS_WIDGET = "workspace-dismiss-widget";
